import type { SimEvent } from "../sim";

/** Vibration in ms per collect (golden is longer) and for a Minuspoäng miss. */
const COLLECT_MS = 15;
const GOLDEN_MS = 40;
const MISS_PATTERN = [20, 40, 20];

/** The vibration pattern a step's events make, or null for none (pure, unit-tested). */
export function vibrationFor(events: readonly SimEvent[]): number[] | null {
	let pattern: number[] | null = null;
	for (const ev of events) {
		if (ev.type === "collected") pattern = [ev.light.golden ? GOLDEN_MS : COLLECT_MS];
		else if (ev.type === "batCaught" || ev.type === "ghostCaught") pattern = [GOLDEN_MS];
		else if (ev.type === "lifeLost") pattern = MISS_PATTERN;
		else if (ev.type === "tricked" && ev.penalty > 0) pattern = MISS_PATTERN;
		else if (ev.type === "missed" && ev.penalty > 0 && !pattern) pattern = MISS_PATTERN;
	}
	return pattern;
}

/**
 * Whether to offer vibration at all: a touch device whose browser has `navigator.vibrate`
 * (Android). iPhones and computers don't get the menu switch.
 */
export function canVibrate(): boolean {
	return (
		typeof navigator !== "undefined" &&
		typeof navigator.vibrate === "function" &&
		typeof window.matchMedia === "function" &&
		window.matchMedia("(pointer: coarse)").matches
	);
}

/** A short buzz on a collect (I-003), when the menu's vibration switch is on. */
export function vibrate(events: readonly SimEvent[], enabled: boolean): void {
	if (!enabled || typeof navigator.vibrate !== "function") return;
	const pattern = vibrationFor(events);
	if (pattern) navigator.vibrate(pattern);
}
